/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_FairInputs */

const en_val_fair = /** @type {(inputs: Val_FairInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fair`)
};

const es_val_fair = /** @type {(inputs: Val_FairInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aceptable`)
};

const fr_val_fair = /** @type {(inputs: Val_FairInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passable`)
};

const de_val_fair = /** @type {(inputs: Val_FairInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Akzeptabel`)
};

const ja_val_fair = /** @type {(inputs: Val_FairInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可`)
};

const zh_val_fair = /** @type {(inputs: Val_FairInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`一般`)
};

const ar_val_fair = /** @type {(inputs: Val_FairInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مقبول`)
};

const id_val_fair = /** @type {(inputs: Val_FairInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cukup`)
};

const it_val_fair = /** @type {(inputs: Val_FairInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Accettabile`)
};

const ru_val_fair = /** @type {(inputs: Val_FairInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удовлетворительное`)
};

const pt_val_fair = /** @type {(inputs: Val_FairInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Razoável`)
};

const ko_val_fair = /** @type {(inputs: Val_FairInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`보통`)
};

/**
* | output |
* | --- |
* | "Fair" |
*
* @param {Val_FairInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_fair = /** @type {((inputs?: Val_FairInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_FairInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_fair(inputs)
	if (locale === "es") return es_val_fair(inputs)
	if (locale === "fr") return fr_val_fair(inputs)
	if (locale === "de") return de_val_fair(inputs)
	if (locale === "ja") return ja_val_fair(inputs)
	if (locale === "zh") return zh_val_fair(inputs)
	if (locale === "ar") return ar_val_fair(inputs)
	if (locale === "id") return id_val_fair(inputs)
	if (locale === "it") return it_val_fair(inputs)
	if (locale === "ru") return ru_val_fair(inputs)
	if (locale === "pt") return pt_val_fair(inputs)
	return ko_val_fair(inputs)
});